import { defineComponent as _defineComponent } from 'vue'
import { watch, onUnmounted } from 'vue';
import Teleport from 'vue2-teleport';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppModal',
  props: {
    isOpen: { type: Boolean },
    ariaLabelledby: null
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'close'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  isOpen: boolean;
  ariaLabelledby?: string;
};





let keydownListener: ((e: KeyboardEvent) => void) | null = null;

function detachKeydown(): void {
  if (!keydownListener) {
    return;
  }

  window.removeEventListener('keydown', keydownListener);
  keydownListener = null;
}

function attachKeydown(): void {
  if (keydownListener) {
    return;
  }

  keydownListener = (e: KeyboardEvent) => {
    if (e.key !== 'Escape') {
      return;
    }

    emit('close');
  };

  window.addEventListener('keydown', keydownListener);
}

watch(
  () => props.isOpen,
  (open) => {
    if (!open) {
      detachKeydown();
      return;
    }

    attachKeydown();
  },
  { immediate: true }
);

onUnmounted(() => {
  detachKeydown();
});

function onBackdropClick(): void {
  emit('close');
}

return { __sfc: true,props, emit, keydownListener, detachKeydown, attachKeydown, onBackdropClick, Teleport }
}

})